import React from 'react';
import { MediaCard } from './Media';
import { PageHeader, Inquiries } from '../Globals';

function OriginalsSorting(props) {
  const today = new Date().toISOString().substring(0, 10);
  let media = props.media.filter(event => event.date <= today);
  media = media.filter(event => event.program === "BIG BANG Tech Report" || event.program.includes("Substack"));
  media = media.sort((a, b) => new Date(b.date) -  new Date(a.date));

  const mediaCards = media.map((media, i) => <MediaCard name={media.name} date={media.date} type={media.type} program={media.program} host={media.host}  description={media.description} image={media.image} link={media.link} key={i} />);

  return(
    <>
      <div className="px-5 mb-5">
        <div className="col-12 my-auto">
          <div className="row d-flex justify-content-center mx-1">
            {mediaCards}
          </div>
        </div>
      </div>
    </>
  );
}

export default function Originals(props) {
  const pageTitle = "Originals";
  const pageDescription = <span>See self-published content from Alvin Wang Graylin</span>;
  
  return (
    <main>
      <div className="container pt-4">
        <div className="row d-flex justify-content-center">
          <PageHeader title={pageTitle} description={pageDescription}/>
          <Inquiries hide="" />
          {props.isFetching ? '' : <OriginalsSorting media={props.media} />}
        </div>
      </div>
    </main>
  );
}